<template>
  <div style="height: 100%;width: 100%;display: flex;flex-direction: row">

    <div v-if="file_type=='others'"  style="width:100%;height: 100%">
      <el-empty description="抱歉，该文件类型暂不支持预览"></el-empty>
    </div>

    <div v-else-if="need_transfer==true"  style="width:100%;height: 100px;line-height: 100px">
      <div style="text-align: center;width: 100%;line-height: 60px;height: 60px">该文件需要转换格式才能预览</div>
      <div style="text-align: center;width: 100%;line-height: 60px;height: 60px">
          <el-button type="primary" @click="startTransfer" :loading="loading">开始格式转换</el-button>
          <el-button type="primary" @click="getPreviewInfo" >刷新</el-button>
          <span>{{transfer_status}}</span>
      </div>

    </div>

    <div v-else-if="file_type=='pdf'" style="width:100%;height: 100%">
      <iframe :src="'/static/pdfjs-3.2.146-dist/web/viewer.html?file=' + url" style="width:100%;height: 100%"/>
    </div>

    <div v-else-if="file_type=='m3d'" style="width:100%;height: 100%">
      <iframe :src="'/static/fileViewers/model3d/index.html#model=' + url" style="width:100%;height: 100%"/>
    </div>

    <div v-else-if="file_type=='ed3d'" style="width:100%;height: 100%">
      <iframe :src="'/static/fileViewers/edviewer/main.html?content_url=' + tranfer_file_url_0"  style="width:100%;height: 100%"/>
    </div>

    <div v-else-if="file_type=='dxf'" style="width:100%;height: 100%">
      <iframe :src="'/static/pdfjs-3.2.146-dist/web/viewer.html?file=' + tranfer_file_url_0" style="width:100%;height: 100%"/>
    </div>

    <div v-else-if="file_type=='dwg'" style="width:100%;height: 100%">
      <iframe :src="'/static/pdfjs-3.2.146-dist/web/viewer.html?file=' + tranfer_file_url_0" style="width:100%;height: 100%"/>
    </div>

    <div v-else-if="file_type=='img'" style="width: 100%;height: 99%;overflow:hidden">
      <img id="img" :style="{transform:'scale(1)'}" :src=url @mousedown.prevent="dropImage" @mouseup.prevent="loosen" @mousewheel.prevent='gunlun'/>
    </div>

    <div v-else-if="file_type=='word'" style="width: 100%;height: 99%;overflow:hidden">
      <vue-office-docx :src=url style="width: 100%; height: 100%"/>
    </div>

    <div v-else-if="file_type=='excel'" style="width: 100%;height: 99%;overflow:hidden">
      <vue-office-excel :src=url style="width: 100%; height: 100%"/>
    </div>

    <div v-else-if="file_type=='ppt'"  style="width:100%;height: 100%">
      <iframe :src="'/static/pdfjs-3.2.146-dist/web/viewer.html?file=' + tranfer_file_url_0" style="width:100%;height: 100%"/>
    </div>

    <div v-else-if="file_type=='mp4'"  style="width:100%;height: 100%">
      <video
          id="myVideo"
          :src="url"
          :controls="true"
          oncontextmenu="return false"
          style="width: 100%;height: 100%;object-fit:fill;" >
      </video>
    </div>

  </div>
</template>

<script>

import VueOfficeDocx from "@vue-office/docx";
import VueOfficeExcel from "@vue-office/excel";
import "@vue-office/excel/lib/index.css";
import "@vue-office/docx/lib/index.css";
//import FileViewerDxf from "./FileViewerDxf";

export default {
  name: "FileViewer",
  components:{VueOfficeDocx,VueOfficeExcel},
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    file_type: {
      type: String
    },
    url: {
      type: String
    }
  },
  data() {
    return {
      file_id:'',
      file_type: 'others',
      need_transfer: false,
      transfer_status:'',
      transfer_file_urls:[],
      tranfer_file_url_0:'',
      loading:false,
      url: '',
      positionX: 0,
      positionY: 0,
      odiv: null,
      timer: null,
      multiples: 1
    }
  },
  methods: {
    gunlun(e) {
      let direction = e.deltaY > 0 ? 'down' : 'up'
      if (direction === 'up') {
        if (this.multiples >= 10) {
          return;
        }
        this.multiples += 0.25;
        // 滑轮向上滚动
      } else {
        if (this.multiples <= 0.5) {
          return;
        }
        this.multiples -= 0.25;
        // 滑轮向下滚动
      }
    },
    dropImage(e) {
      if (e === null) {
        return
      }
      this.odiv = e.target;        //获取目标元素
      //算出鼠标相对元素的位置
      let disX = e.clientX - this.odiv.offsetLeft;
      let disY = e.clientY - this.odiv.offsetTop;
      document.onmousemove = (e) => {       //鼠标按下并移动的事件
                                            //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        let left = e.clientX - disX;
        let top = e.clientY - disY;

        //绑定元素位置到positionX和positionY上面
        this.positionX = top;
        this.positionY = left;

        //移动当前元素
        this.odiv.style.left = left + 'px';
        this.odiv.style.top = top + 'px';
      }
    },
    loosen() {
      document.onmousemove = null;
      document.onmouseup = null;
    },
    setFileId(fileId){
      this.file_id = fileId
      if(fileId && fileId.length>0){
        this.getPreviewInfo()
      }
    },
    async getPreviewInfo() {
      let previewInfo = await this.$http('sysFilePreviewService.getPreviewInfo', {id: this.file_id})
      this.file_type = previewInfo.file_type
      this.url = previewInfo.url
      this.need_transfer = previewInfo.need_transfer
      this.transfer_status = previewInfo.transfer_status
      this.transfer_file_urls = previewInfo.transfer_file_urls

      //第一个文件url，方便使用
      if(this.transfer_file_urls && this.transfer_file_urls.length>0){
        this.tranfer_file_url_0 = this.transfer_file_urls[0]
      }

      this.loading = "on_progress" == this.transfer_status;
    },
    async startTransfer() {
      this.$http('sysFilePreviewService.startTransfer', {id: this.file_id})
      this.loading = true;
    },
    autoRefresh(){
      if(this.loading){
        this.getPreviewInfo();
      }
    }
  },
  mounted() {
    this.timer = setInterval(this.autoRefresh, 2000);
    if(this.parentData.file_id && this.parentData.file_id.length>0){
      this.setFileId(this.parentData.file_id)
    }
  },
}
</script>

<style scoped>

img {
  height: 100%;
  width: auto;
  position: relative;
}

</style>
